export default __webpack_public_path__ + "static/media/lato-regular.f4937367.woff2";